import { render, staticRenderFns } from "./DocumentImporter.vue?vue&type=template&id=ef3efdc4&scoped=true&"
import script from "./DocumentImporter.vue?vue&type=script&lang=js&"
export * from "./DocumentImporter.vue?vue&type=script&lang=js&"
import style0 from "./DocumentImporter.vue?vue&type=style&index=0&id=ef3efdc4&prod&lang=css&"
import style1 from "./DocumentImporter.vue?vue&type=style&index=1&id=ef3efdc4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef3efdc4",
  null
  
)

export default component.exports